export const getSite = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return ""; 
};

export const setSite = (cname, cvalue) => {
    const d = new Date();
    d.setTime(d.getTime() + (10*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";     
    // Also set this in cookie/localStorage
};
export const covertIPToNumber = (deviceIP) => {
    //console.log("covertIPToNumber", deviceIP)
    return deviceIP ? (deviceIP.split('.').reduce(function(IPInt, octet) { return (IPInt<<8) + parseInt(octet, 10)}, 0) >>> 0) : 0 ;
}